export const getParamFromUrl = (key: string, url: string): string => {
    if (!url) {
        return ''
    }
    // Url doesn't have question mark
    if (url.indexOf('?') < 0) {
        return ''
    }
    const splittedUrl = url && url.split('?') || []
    // splitted url array don't have 
    if (splittedUrl.length < 1) {
        return ''
    }
    const rawQueryString = splittedUrl[1]
    // Have query string with key but no value exist (No '=' in query string)
    if (rawQueryString.indexOf('=') < 0) {
        return ''
    }
    const queryArray = rawQueryString.split('&')
    let returnValue = ''
    for (let i = 0; i < queryArray.length; i++) {
        const queryItem = queryArray[i].split('=')
        if (queryItem.length < 0) {
            continue
        }
        if (queryItem[0] === key) {
            returnValue = queryItem[1] ?? ''
            returnValue = decodeURIComponent(returnValue)
            break
        }
    }
    return returnValue
}
